import script from "./WriteTest.vue?vue&type=script&setup=true&lang=js"
export * from "./WriteTest.vue?vue&type=script&setup=true&lang=js"

import "./WriteTest.vue?vue&type=style&index=0&id=59d848c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d848c5"]])

export default __exports__